import React, { useCallback } from "react";

import { TabBarWrapper } from "../../../../components/TabBar/TabBar/TabBar";
import { getNavProps } from "../../helpers";
import { TabBarItem } from "../../../../components/TabBar/TabBarItem/TabBarItem";
import IFramePanel from "../IFramePanel";
import useIframeBodies from "../IFramePanel/hooks/useIframeBodies";
import useHttpResponse from "../IFramePanel/hooks/useHttpResponse";
import { setTabIndex } from "../../steps/Three/services/stepThree";

import styles from "./styles.module.scss";

const IFramesTabs = React.memo(({
    includesSelectors,
    menuProps,
    onLoaded,
    onElementClick,
    setCurrentIframeRef,
    setCurrentIframeWrapperRef
}) => {
    const httpResponse = useHttpResponse();
    const {
        onSetIframe,
        onSetIframeWrapper
    } = useIframeBodies(setCurrentIframeRef, setCurrentIframeWrapperRef);

    const handleTabClick = useCallback(
        (active, index) => {
            setTabIndex(index);
        },
        []
    );

    if(!httpResponse?.length) {
        return null;
    }

    return (
        <TabBarWrapper
            className={styles.tabBarWrapper}
            navProps={getNavProps(httpResponse, includesSelectors)}
            onClickTab={handleTabClick}
        >
            {
                httpResponse.map((data, i) => (
                    <TabBarItem
                        key={i}
                        label={`Example - ${i+1}`}
                    >
                        <IFramePanel
                            data={data}
                            onElementClick={onElementClick}
                            menuProps={menuProps}
                            onSetIframe={onSetIframe}
                            onSetIframeWrapper={onSetIframeWrapper}
                        />
                    </TabBarItem>
                ))
            }
        </TabBarWrapper>
    );
});

export default IFramesTabs;
